module.exports = __webpack_public_path__ + "static/WEDDING E&M-341-e2e5e084070e2d42eb62daeb6925cbb8.jpg";